import { render, staticRenderFns } from "./ChoosePayment.vue?vue&type=template&id=3bc852a8&scoped=true"
import script from "./ChoosePayment.vue?vue&type=script&lang=ts"
export * from "./ChoosePayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc852a8",
  null
  
)

export default component.exports